module.exports = __webpack_public_path__ + "triangles.d069cdfa41ac01e39b99e824cd8592fd.png";